import { render, staticRenderFns } from "./VideoLibrary.vue?vue&type=template&id=7e570d1a&scoped=true"
import script from "./VideoLibrary.vue?vue&type=script&lang=js"
export * from "./VideoLibrary.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./VideoLibrary.vue?vue&type=style&index=1&id=7e570d1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e570d1a",
  null
  
)

export default component.exports